import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderStatsTimeIntervalAggregateSlice = createApi({
    reducerPath: "orderStatsTimeIntervalAggregate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        orderStatsTimeIntervalAggregate: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/orders/aggregate-channel-wise", params: data, method: "GET" }),
        }),
    }),
});

export const { useOrderStatsTimeIntervalAggregateQuery } = orderStatsTimeIntervalAggregateSlice;
